module.exports = __webpack_public_path__ + "static/img/06@2x.b905a893.png";